<template>
  <div class="card">
    <div class="pb-0 card-header mb-0">
      <h6>{{ title }}</h6>
      <p class="text-sm">
        <span class="font-weight-bold">{{ detail1 }}</span>
        {{ detail2 }}
      </p>
    </div>
    <div class="p-3 card-body">
      <div class="chart">
        <canvas id="chart-line" class="chart-canvas" height="300"></canvas>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from "chart.js/auto";
import { mapActions } from 'vuex';

export default {
  name: "gradient-line-chart",
  data() {
    return {
      data: {},
    }
  },
  props: {
    title: {
      type: String,
      default: "Producción terminadas por mes",
    },
    detail1: {
      type: String,
      default: "",
    },
    detail2: {
      type: String,
      default: "",
    },
  },
  methods: {
    ...mapActions('analitycs', ['getYear']), // Asegúrate de que esta acción esté definida en tu store

    async fetchYearAnalytics() {
      let grafico = await this.getYear(); 

      console.log(JSON.stringify(grafico.data));

      this.data = grafico.data;
      this.updateChart();
    },
    updateChart() {
      const months = [];
      const quantities = [];
       
      Object.values(this.data).forEach(data => {
        // Crear un label que incluya el mes y los detalles de producción
        let details = '';
        if (data.details) {
          details = Object.values(data.details).map(detail => `Modelo ${detail.model_id}: ${detail.total_quantity} unidades`).join(', ');
        }
        months.push(`${data.month} (${details})`); // Concatenar mes con detalles
        quantities.push(data.total_quantity); // Cantidades
      });
      
      var ctx1 = document.getElementById("chart-line").getContext("2d");

      var gradientStroke1 = ctx1.createLinearGradient(0, 230, 0, 50);
      gradientStroke1.addColorStop(1, "rgba(94, 114, 228, 0.2)");
      gradientStroke1.addColorStop(0.2, "rgba(94, 114, 228, 0.0)");
      gradientStroke1.addColorStop(0, "rgba(94, 114, 228, 0)");

      new Chart(ctx1, {
        type: "bar", // Tipo de gráfico
        data: {
          labels: months,
          datasets: [
            {
              label: "Total Cantidad", // Etiqueta del conjunto de datos
              tension: 0.4,
              pointRadius: 0,
              borderColor: "#4BB543",
              backgroundColor: gradientStroke1,
              borderWidth: 3,
              fill: true,
              data: quantities, // Usar cantidades en lugar de precios
              barThickness: 50, // Grosor de las barras
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: true, // Mostrar leyenda
            },
            tooltip: {
              callbacks: {
                label: function (context) {
                  const index = context.dataIndex; 
                  return [
                    `Cantidad: ${quantities[index]}`, // Mostrar cantidad en el tooltip
                  ];
                },
              },
            },
          },
          interaction: {
            intersect: false,
            mode: "index",
          },
          scales: {
            y: {
              grid: {
                drawBorder: false,
                display: true,
                drawOnChartArea: true,
                drawTicks: false,
                borderDash: [5, 5],
              },
              ticks: {
                display: true,
                padding: 10,
                color: "#fbfbfb",
                font: {
                  size: 11,
                  family: "Open Sans",
                  style: "normal",
                  lineHeight: 2,
                },
              },
            },
            x: {
              grid: {
                drawBorder: false,
                display: false,
                drawOnChartArea: false,
                drawTicks: false,
                borderDash: [5, 5],
              },
              ticks: {
                display: true,
                color: "#ccc",
                padding: 20,
                font: {
                  size: 11,
                  family: "Open Sans",
                  style: "normal",
                  lineHeight: 2,
                },
              },
              offset: true, // Centrar las barras con respecto a los labels
            },
          },
        },
      });
    }
  },
  mounted() {
    this.fetchYearAnalytics();
  },
};
</script>